








import { Component, Vue, Watch } from 'vue-property-decorator'
import { Getter, Action, State } from 'vuex-class'
import { GET_JOB_LIST, GET_IS_CONNECTED } from '@/system/store/getter-types'
import { FETCH_JOB_LIST_ACTION, FETCH_PROJECT_LIST_ACTION, CLEAR_JOB } from '@/system/store/action-types'
import { IJob } from '@/features/job/store'
import { IActionType, IStore } from '@/system/store'
import JobListHeader from '@/features/job/components/JobListHeader.vue'
import JobList from '@/features/job/components/JobList.vue'
import { UPLOAD_NAME } from '@/features/upload/upload.router'
import { Dictionary } from 'vue-router/types/router'
import DualRing from '@/shared/loaders/LoaderDualRing.component.vue'

@Component({
  components: {
    JobListHeader,
    JobList
  }
})
export default class JobListView extends Vue {
  @State(({ job }: IStore) => job.job) job!: IJob
  @Getter(GET_JOB_LIST)
  jobList!: IJob[]
  @Getter(GET_IS_CONNECTED)
  isConnected!: boolean
  @Action(FETCH_JOB_LIST_ACTION)
  fetchJobList!: IActionType
  @Action(FETCH_PROJECT_LIST_ACTION)
  fetchProjects!: IActionType
  @Action(CLEAR_JOB)
  clearJob!: IActionType

  @Watch('isConnected')
  async getJobList () {
    await Promise.all([
      this.fetchJobList(),
      this.fetchProjects()
    ])
  }

  @Watch('jobList')
  showJobList () {
    if (!this.hasJobList) this.$router.push({ name: UPLOAD_NAME })
    this.$q.loading.hide()
  }

  get jobs (): IJob[] {
    const { removedJobId } = this.$route.params as Dictionary<'removedJobId'>
    const jobs = this.jobList.filter(({ jobId }: IJob) => removedJobId !== jobId)
    const actualJobList = this.jobList.map((item: IJob) => {
      if (item.jobId === this.job.jobId) item = this.job
      return item
    })

    return actualJobList
  }

  get hasJobList (): boolean {
    return Boolean(this.jobs.length)
  }

  protected async created (): Promise<void> {
    if (this.isConnected) {
      this.showDualRingSpinner()
      await Promise.all([
        this.clearJob(),
        this.fetchJobList(),
        this.fetchProjects()
      ])
    }
  }

  private showDualRingSpinner (): void {
    this.$q.loading.show({
      spinner: DualRing as any
    })
  }
}
